import { Button } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface IShowBankAccountDetailsLogsButtonProps {
    onClick: () => void;
}

export function ShowBankAccountDetailsLogsButton(props: IShowBankAccountDetailsLogsButtonProps) {
    return (
        <Button
            onClick={props.onClick}
            variant="link"
        >
            {getSelectedLanguage().bankAccountDetailsLog.viewChangesLog}
        </Button>
    );
}
